<template>
  <div :class="bascrollClass" ref="wrapper" style="width: 100%;height: 100%;">
    <slot />
  </div>
</template>

<script>
import BScroll from 'better-scroll'

const DIRECTION_H = 'horizontal'
const DIRECTION_V = 'vertical'
const COMPONENTS_NAME = 'base-scroll'

export default {
  name: COMPONENTS_NAME,
  props: {
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: false
    },
    listenScroll: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: null
    },
    pullup: {
      type: Boolean,
      default: false
    },
    beforeScroll: {
      type: Boolean,
      default: false
    },
    refreshDelay: {
      type: Number,
      default: 20
    },
    direction: {
      type: String,
      default: DIRECTION_V
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.isBScroll) {
        const __timeout = setTimeout(() => {
          clearTimeout(__timeout);
          this._initScroll()
          this.refresh();
        }, 20)
      }
    });
  },
  watch: {
    ['$root.clientWidth']() {
      this.updatedRefresh();
    },
    data() {
      this.updatedRefresh();
    }
  },
  computed: {
    isBScroll() {
      return this.$root.getIosVersion && this.$root.getIosVersion.length && this.$root.getIosVersion[0] < 12;
    },
    bascrollClass() {
      return this.isBScroll && 'wrapper position-relative' || 'scroll-touch';
    },
    isAndroid() {
      return window?.navigator?.userAgent?.toLocaleLowerCase()?.indexOf('android') !== -1;
    }
  },
  updated() {
    this.updatedRefresh();
  },
  methods: {
    updatedRefresh() {
      if(this.isBScroll) {
        const __timeout = setTimeout(() => {
          clearTimeout(__timeout);
          this.refresh()
        }, this.refreshDelay)
      }
    },
    _initScroll () {
      if (!this.$refs.wrapper) {
        return
      }
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        cancelable: true,
        eventPassthrough: this.direction === DIRECTION_V ? DIRECTION_H : DIRECTION_V
      })
      if (this.listenScroll) {
        this.scroll.on('scroll', (pos) => {
          this.$emit('scroll', pos)
        })
      }
      if (this.pullup) {
        this.scroll.on('scrollEnd', () => {
          if (this.scroll.y <= (this.scroll.maxScrollY + 50)) {
            this.$emit('scrollToEnd')
          }
        })
      }
      if (this.beforeScroll) {
        this.scroll.on('beforeScrollStart', () => {
          this.$emit('beforeScroll')
        })
      }
    },
    disable () {
      this.scroll && this.scroll.disable()
    },
    enable () {
      this.scroll && this.scroll.enable()
    },
    refresh () {
      this.scroll && this.scroll.refresh()
    },
    scrollTo () {
      this.scroll && this.scroll.scrollTo.apply(this.scroll, arguments)
    },
    scrollToElement () {
      this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
    }
  }
}
</script>

<style scoped lang="stylus">
  .wrapper {
    overflow: hidden;
    position: absolute;
    top:0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: auto;
  }
</style>